import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import firebase from "../../util/firebaseConfig";
// TODOs logo visual'dan alınacak.
import alertify from "alertifyjs";
import { Form, Grid, Header, Image, Segment, Message } from "semantic-ui-react";
const SignIn = () => {
  const uid = useSelector((state) => state.firebase.auth.uid);
  const isVerified = useSelector((state) => state.firebase.auth.emailVerified);
  const [isClick, setClick] = useState(false);
  // TODOs sayfa otomatik güncellenmeli
  const handleSubmit = (e) => {
    e.preventDefault();
    firebase
      .auth()
      .currentUser.sendEmailVerification()
      .then(() => {
        alertify.success(
          "Email sent successfully, please check your email address."
        );
      })
      .then(() => {
        setClick(true);
      })
      .catch((err) => {
        alertify.error(`${err}`);
      });
  };

  if (!uid) return <Redirect to="/signin" />;
  if (isVerified && isVerified) return <Redirect to="/" />;
  return (
    <Grid
      textAlign="center"
      style={{ height: "79.5vh" }}
      verticalAlign="middle"
    >
      <Grid.Column
        style={{
          maxWidth: 450,
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        }}
      >
        <Header
          as="h2"
          color="blue"
          textAlign="center"
          style={{ paddingTop: "6px" }}
        >
          <Image
            src="https://firebasestorage.googleapis.com/v0/b/omnes-immigration.appspot.com/o/assets%2Fimages%2Ficon-set%2Ficon-america.png?alt=media&token=3a531c4a-5eff-43e5-a019-1d3c519cb18b"
            style={{ marginTop: "-6px", marginRight: "8px" }}
          />{" "}
          <span
            style={{
              color: "royalblue",
            }}
          >
            Verify your account
          </span>
        </Header>
        <Message success={isVerified} error={!isVerified} floating="left">
          <Message.Content>
            <Message.Header>
              Status: {JSON.stringify(isVerified)}
            </Message.Header>
            {isVerified ? "Verified" : "Not Verified"}
          </Message.Content>
        </Message>
        <Form size="large" onSubmit={handleSubmit}>
          <Segment stacked>
            {!isClick ? (
              <Form.Button
                disabled={isVerified}
                style={{ backgroundColor: "royalblue", color: "white" }}
                fluid
                type="submit"
                size="large"
              >
                Send Email Verification Link
              </Form.Button>
            ) : (
              <Form.Button
                onClick={() => window.location.reload()}
                style={{ backgroundColor: "royalblue", color: "white" }}
                fluid
                type="submit"
                size="large"
              >
                If you have verified your email address refresh the page
              </Form.Button>
            )}
          </Segment>
        </Form>
      </Grid.Column>
    </Grid>
  );
};

export default SignIn;
